const megabytes = (num: number) => num * 1024 * 1024

export const appConfig = {
  aiChat: {
    allowFileUpload: false,
    attachmentAllowedTypes: {
      'application/pdf': ['.pdf'],
      'image/heic': ['.heic'],
      'image/jpeg': ['.jpg', '.jpeg'],
      'image/png': ['.png'],
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document': ['.docx'],
    },
    attachmentMaxSize: megabytes(4),
  },
  documentUpload: {
    allowedFileTypes: {
      'application/pdf': ['.pdf'],
      'image/heic': ['.heic'],
      'image/jpeg': ['.jpg', '.jpeg'],
      'image/png': ['.png'],
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document': ['.docx'],
    },
    maxUploadSize: megabytes(100),
  },
  isLocalDeveloperMode: import.meta.env.VITE_DEV === 'true',
}
